<template>
	<WelcomePopup ref="welcomeModal" />
	<GenericPopup ref="genericModal" />
	<AskNamePopup ref="askNamePopup" />
</template>

<script setup>
import { getCurrentInstance, ref, computed } from 'vue';
import WelcomePopup from './welcome-popup.vue';
import GenericPopup from './generic-popup.vue';
import AskNamePopup from './ask-name-popup.vue';
import { useUserStore } from '@/js/stores/user';

const userStore = useUserStore()

// Register a global shortcut to this component
window.$modalWrapper = getCurrentInstance()

// Refs
const genericModal = ref()
const welcomeModal = ref()
const askNamePopup = ref()

// Computeds
const firstName = computed(() => userStore.userFirstName)
const lastName = computed(() => userStore.userLastName)

// Methods
function openGenericModal(html, params) {
	genericModal.value.open(html, params)
}

function openWelcomeModal() {
	welcomeModal.value.opened = true
}

function openAskNameModal(){
	// Ask user's name if not known
	askNamePopup.value.opened = true
	askNamePopup.value.firstName = firstName.value
	askNamePopup.value.lastName = lastName.value
}

// Expose
defineExpose({
	openGenericModal,
	openAskNameModal,
	openWelcomeModal
})
</script>